/**
 * 微信公众号
 */

// @ts-ignore
import $wxsdk from '@/sheep/libs/sdk-h5-weixin';

// @ts-ignore
import { getRootUrl } from '@/sheep/helper';

// @ts-ignore
import AuthUtil from '@/sheep/api/member/auth';

// @ts-ignore
import SocialApi from '@/sheep/api/member/social';

/** 社交类型 - 微信公众号 */
const socialType = 31;

/** 加载微信公众号JSSDK */
async function load() {
  $wxsdk.init();
}

/**
 * 微信公众号登录
 * @param code 授权code
 * @param state 状态
 * @returns 登录结果
 */
async function login(code = '', state = ''): Promise<any> {
  // 情况一：没有 code 时，去获取 code
  if (!code) {
    const loginUrl = await getLoginUrl();
    if (loginUrl) {
      uni.setStorageSync('returnUrl', location.href);
      window.location.href = loginUrl;
    }
    return false;
  } else {
    // 情况二：有 code 时，使用 code 去自动登录
    const loginResult = await AuthUtil.socialLogin(socialType, code, state);
    if (loginResult.code === 0) {
      setOpenid(loginResult.data.openid);
      return loginResult;
    }
    return false;
  }
}

/**
 * 微信公众号绑定
 * @param code 授权code
 * @param state 状态
 * @returns 绑定结果
 */
async function bind(code = '', state = ''): Promise<any> {
  // 情况一：没有 code 时，去获取 code
  if (code === '') {
    const loginUrl = await getLoginUrl('bind');
    if (loginUrl) {
      uni.setStorageSync('returnUrl', location.href);
      window.location.href = loginUrl;
    }
    return false;
  } else {
    // 情况二：有 code 时，使用 code 去自动绑定
    const loginResult = await SocialApi.socialBind(socialType, code, state);
    if (loginResult.code === 0) {
      setOpenid(loginResult.data);
      return loginResult;
    }
    return false;
  }
}

/**
 * 微信公众号解除绑定
 * @param openid 微信openid
 * @returns 是否解绑成功
 */
const unbind = async (openid: string): Promise<boolean> => {
  const { code } = await SocialApi.socialUnbind(socialType, openid);
  return code === 0;
};

/**
 * 获取公众号登录地址
 * @param event 事件类型：login | bind
 * @returns 登录地址
 */
async function getLoginUrl(event = 'login'): Promise<string | undefined> {
  const page = getRootUrl() + 'pages/index/login' + '?event=' + event;
  const { code, data } = await AuthUtil.socialAuthRedirect(socialType, page);
  if (code !== 0) {
    return undefined;
  }
  return data;
}

/**
 * 设置 openid 到本地存储
 * @param openid 微信openid
 */
function setOpenid(openid: string) {
  uni.setStorageSync('openid', openid);
}

/**
 * 获得 openid
 * @param force 是否强制获取
 * @returns openid
 */
async function getOpenid(force = false): Promise<string | undefined> {
  let openid = uni.getStorageSync('openid');
  if (!openid && force) {
    const info = await getInfo();
    if (info && info.openid) {
      openid = info.openid;
      setOpenid(openid);
    }
  }
  return openid;
}

/**
 * 获得社交信息
 * @returns 社交用户信息
 */
async function getInfo(): Promise<any | undefined> {
  const { code, data } = await SocialApi.getSocialUser(socialType);
  if (code !== 0) {
    return undefined;
  }
  return data;
}

export default {
  load,
  login,
  bind,
  unbind,
  getInfo,
  getOpenid,
  jsWxSdk: $wxsdk,
};
